import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { connect } from 'react-redux';
import setProductAction from '../../redux/actions/createReferenceActions/actionProduct'
import { withTranslation } from 'react-i18next';

const filterOptions = createFilterOptions({
    ignoreAccents: true,
    limit: 20,
});

class ProductForm extends React.Component {
    _isMounted = false;
   
    constructor(props) {
        super(props);
        this.state = { product: '', products: { data: [{ 'productname': '' }] }, errorAmount: false, errorRequired: false };
        this.handleChangeForm = this.handleChangeForm.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getSelectedItem = this.getSelectedItem.bind(this);
        this.props.setProductFunction('defaultProduct')

    }

    async componentDidMount() {
        this._isMounted = true;

        // get all products from Database for Autocomplete
        const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/createRef/products?language=${localStorage.getItem('language')}`);
        const json = await response.json();
        if (this._isMounted) {
            this.setState({ products: json });
        }
        
        // get all productnames by productnumber
        for (const [key, value] of Object.entries(this.props.selectedReferenceData)) {

            if (key === 'product_1' || key === 'product_2' || key === 'product_3'
                || key === 'product_4' || key === 'product_5' || key === 'product_6'
                || key === 'product_7' || key === 'product_8' || key === 'product_9' || key === 'product_10') {
                if (value !== 'null') {
                    const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/viewRef/search/product?product=${this.props.selectedReferenceData[key]}`);
                    const json = await response.json();
                    if (this._isMounted) {
                        this.setState({ product: [...this.state.product, json.data[0]] }, () => {
                            this.props.setProductFunction(this.state.product)
                        })                    
                    }
                }
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async handleChange(event) {

        this.setState({ ...this.state.product, product: event.target.value });

        const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/createRef/products?language=${localStorage.getItem('language')}`);
        const json = await response.json();
        // console.log(json)
        this.setState({ ...this.state.products, products: json });
    };

    handleChangeForm(event, value) {
        if (value !== null) {
            if (Object.keys(value).length <= 10) {
                this.setState({ product: value }, () => {
                    this.props.setProductFunction(this.state.product)
                });
                this.setState({ errorAmount: false });
            } else {
                this.setState({ errorAmount: true });
            }

            //error handling: min 1 product
            if (Object.keys(value).length < 1) {
                this.setState({ errorRequired: true });
            } else {
                this.setState({ errorRequired: false });
            }

        } else {
            this.setState({ product: 'defaultProduct' }, () => {
                // this.props.setProductFunction(this.state.product);
            });
        }
    }

    getSelectedItem() {

        let value = []
        Object.values(this.state.product).map((index, key) => {
            if(index !== undefined && index !== undefined) {
            value.push({ productname: index.productname, productnumber: index.productnumber, productsystem: index.productsystem })
            return value
            }
            return ''
        })

        return value;
    }
    shouldComponentUpdate(nextProps, nextState) {
        this.props.setProductFunction(this.state.product);
        return true;
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <Autocomplete
                    multiple
                    options={this.state.products.data}
                    id="combo-box-product"
                    limitTags={1}
                    filterOptions={filterOptions}
                    autoComplete={true}
                    value={this.getSelectedItem()}
                    onChange={this.handleChangeForm}
                    getOptionLabel={(option) => option.productname}
                    isOptionEqualToValue={(option, value) => option.productname === value.productname}
                    getOptionDisabled={() => this.state.errorAmount ? true : false}
                    sx={{
                        "&:hover ": {
                            borderColor: "rgb(0,191,255)"
                        },
                        '& label.Mui-focused': {
                            color: 'white'
                        },
                        '& .MuiAutocomplete-tag':{
                            color: 'black',
                            backgroundColor: "white",
                        },
                        input: { color: 'white'  },
                        '& .MuiOutlinedInput-root': {
                            '&:hover fieldset': {
                                borderColor: 'rgb(0,191,255)',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'rgb(47, 79, 79)',
                            },
                        },
                    }}
                    renderInput={(params) => (<TextField {...params} sx={{
                        input: { color: 'white'  },
                    }} style={{ fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)', width: 300 }}
                        variant="outlined" error={this.props.errorRequiredProd} label={t("create_ref.products_label")} placeholder={t("create_ref.products_placeholder")} />)}
                />
            </div>
            //  onChange={this.handleChange}
        );

    }
}
function mapStateToProps(state) {
    return {
        errorRequiredProd: state.createRefState.errorRequiredProd,
        selectedReferenceData: state.showRefState.selectedReferenceData
    }
}

// set props to redux-store
function mapDispatchToProps(dispatch) {
    return {
        setProductFunction: product => {
            dispatch(setProductAction(product))
        }
    }
}

// export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ProductForm));
export default connect(mapStateToProps, mapDispatchToProps)((withTranslation()(ProductForm)));